import React from 'react';

import { useAuthorization } from '@/core/hooks';
import { FullView, Spin } from '@/components';

import './index.css';

export function Authorize<T>(Component: React.FC<T>, permission: string): React.FC<T> {
  // eslint-disable-next-line react/display-name
  return (props: any) => {
    const { isAuthorized } = useAuthorization(permission);

    if (isAuthorized) {
      return <Component {...props} />;
    }

    return (
      <FullView className='container-center'>
        <Spin />
      </FullView>
    );
  };
}
